import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { useState } from 'react'
import { SubmitP2PReport } from '../../../../services/peerToPeer/PeerToPeerService'

interface Props {
  open: boolean
  reportingYearId: number
  onClose: () => void
  onSubmitted: () => void
}

export const SubmitReportModal = ({ open, reportingYearId, onClose, onSubmitted }: Props): JSX.Element => {
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false)
  const [error, setError] = useState<string | null>(null)

  const submit = async (): Promise<void> => {
    setIsSubmitting(true)
    setError(null)
    const result = await SubmitP2PReport({ reportingYearId })
    setIsSubmitting(false)
    if (!result.success) {
      setError(result.errors[0] ?? 'Unable to submit your report. Please try again.')
      return
    }
    onSubmitted()
  }

  return (
    <Dialog open={open} onClose={onClose} data-testid='p2pSubmitReportModal'>
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pr: '8px' }}>
        Ready to Submit?
        <IconButton onClick={onClose} disabled={isSubmitting} size='small' aria-label='close' data-testid='p2pSubmitReportClose'><CloseIcon fontSize='small' /></IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography variant='body1'>You&apos;re all set! Once submitted, your report will be sent to the START team.</Typography>
        {error != null && <Box sx={{ mt: '12px' }}><Alert severity='error' data-testid='p2pSubmitReportError'>{error}</Alert></Box>}
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' onClick={onClose} disabled={isSubmitting} data-testid='p2pSubmitReportNotYet'>Not Yet</Button>
        <Button variant='contained' color='primary' onClick={() => { void submit() }} disabled={isSubmitting} data-testid='p2pSubmitReportConfirm'>Submit</Button>
      </DialogActions>
    </Dialog>
  )
}
